import './sleep-tips.css';
import React, {useEffect, useState, useRef} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import {
  BetterSleepTipsStoriesData,
  SleepTipsRelaxationStoriesData
} from '../../assets/SleepTipsStoriesData/SleepTipsStoriesData';
import Routes from "../../assets/RoutesToPages/Routes";
import {ReactComponent as SleepTipsMainImg} from './img-sleep-tips/main-img.svg';


const SleepTipsPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const {pageID} = location.state || '';
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const [progress, setProgress] = useState(Array(pageID === "physical-relaxation" ?
    SleepTipsRelaxationStoriesData.length : BetterSleepTipsStoriesData.length).fill(0));
  const [mouseDown, setMouseDown] = useState(false);
  const [clickTimeout, setClickTimeout] = useState(null);
  const intervalRef = useRef(null);
  const canvasRef = useRef([]);
  // const canvasElementRef = useRef(null);
  const timerFadeIn = useRef(null);
  const storyRecommendationRef = useRef(null);
  const storyImgRef = useRef(null);
  const storyRef = useRef(null);


  useEffect(() => {
    if (!isPaused) {
      startTimer();
    }

    return () => {
      clearInterval(intervalRef.current);
    };
  }, [currentIndex, isPaused]);


  const startTimer = () => {
    // const scale = window.devicePixelRatio || 1;
    // const step = scale === 1 ? 1 : 2;
    const step = 1;
    let progressToUpdate = progress[currentIndex];

    intervalRef.current = setInterval(() => {
      setProgress((prevProgress) => {
        const updatedProgress = [...prevProgress];
        progressToUpdate += step;

        if (progressToUpdate >= 100) {
          clearInterval(intervalRef.current);
          updatedProgress[currentIndex] = 100;
          nextStory();
        } else {
          updatedProgress[currentIndex] = progressToUpdate;
        }

        return updatedProgress;
      });
    }, 80);
  };


  const nextStory = () => {
    if (currentIndex < (pageID === "physical-relaxation" ?
      (SleepTipsRelaxationStoriesData.length - 1) : BetterSleepTipsStoriesData.length - 1)) {
      setCurrentIndex(prevIndex => {
        const newProgress = [...progress];
        newProgress[prevIndex + 1] = 0;
        setProgress(newProgress);
        return prevIndex + 1;
      });
    }
  };


  const prevStory = () => {
    if (currentIndex > 0) {
      clearInterval(intervalRef.current);

      setProgress((prevProgress) => {
        const updatedProgress = [...prevProgress];
        for (let i = currentIndex; i >= 0; i--) {
          updatedProgress[i] = 0;
        }
        return updatedProgress;
      });

      setCurrentIndex(prevIndex => prevIndex - 1);
    }
  };


  const pause = () => {
    setIsPaused(true);
    clearInterval(intervalRef.current);
  };


  const resume = () => {
    setIsPaused(false);
    startTimer();
  };


  const handleMouseDown = () => {
    setMouseDown(true);

    if (clickTimeout) clearTimeout(clickTimeout);
    const timeout = setTimeout(() => {
      setClickTimeout(null);
    }, 200);
    setClickTimeout(timeout);

    pause();
  };


  const handleMouseUp = () => {
    if (mouseDown) {
      resume();
    }
    setMouseDown(false);
  };


  const handleMouseClick = (e) => {
    if (
      // !mouseDown &&
      clickTimeout) {
      const width = e.currentTarget.clientWidth;
      const clickPosition = e.clientX - e.currentTarget.getBoundingClientRect().left;

      if (clickPosition < width / 2) {
        prevStory();
      } else {
        nextStory();
      }
    }
  };


  const drawProgressBar = (ctx, progressPercent) => {
    const width = ctx.canvas.width;
    const height = ctx.canvas.height;

    const progressWidth = (width * progressPercent) / 100;

    ctx.clearRect(0, 0, width, height);
    ctx.fillStyle = "#fff";
    ctx.fillRect(0, 0, progressWidth, height);
  };


  useEffect(() => {
    if (canvasRef.current[currentIndex]) {
      const ctx = canvasRef.current[currentIndex].getContext("2d");
      drawProgressBar(ctx, progress[currentIndex]);
    }
  }, [progress, currentIndex]);


  useEffect(() => {
    if (storyRecommendationRef.current) {

      if (currentIndex === 0) {
        storyImgRef.current.classList.add('story-fade');
      }

      storyRecommendationRef.current.classList.add('story-fade');

      timerFadeIn.current = setTimeout(() => {
        if (currentIndex === 0) {
          storyImgRef.current.classList.remove('story-fade');
        }

        storyRecommendationRef.current.classList.remove('story-fade');
      }, 405)
    }

    return () => {
      clearTimeout(timerFadeIn.current)
    }
  }, [currentIndex]);


  useEffect(() => {
    if (progress[currentIndex] === 100) {
      navigate(Routes.sleepPage);
    }
  }, [progress]);

  return (
    <div className='sleep-tips-container'>
      <p className='sleep-tips-container__title'>Spánok</p>
      <div className='sleep-tips-content'>
        <SleepTipsMainImg className="sleep-tips-content-logo"
                          width='158'
                          height='149'/>
        <div className='sleep-tips-navigation'>
          <img className='sleep-tips-navigation__arrow'
               onClick={() => navigate(-1)}
               loading="lazy"
               src={require("./img-sleep-tips/back_arrow.svg").default}
               width='24'
               height='24'
               alt="image arrow left"/>
          <span
            className={`sleep-title-category ${pageID !== "physical-relaxation" ? 'better-sleep-title-category' : ''}`}>
            {pageID === "physical-relaxation" ? 'Tipy na fyzickú relaxáciu' : 'Tipy na lepší spánok'}
          </span>
        </div>
        <div className='sleep-specified-tip-container'>
          <div ref={storyRef}
               className="story-container">
            <div className="progress-container">
              {(pageID === "physical-relaxation" ?
                SleepTipsRelaxationStoriesData : BetterSleepTipsStoriesData)
                .map((story, index) => (
                  <div key={story.id}
                       className="progress-bar"
                       style={{
                         height: index <= currentIndex ? "4px" : "2px",
                         background: index < currentIndex ? "#fff" : "rgba(255, 255, 255, 0.4)",
                       }}>
                    {index === currentIndex && (
                      <canvas className="progress-fill"
                        // ref={canvasElementRef}
                              style={{
                                width: `${progress[currentIndex]}%`,
                                background: "#fff",
                              }}/>)}
                  </div>
                ))}
            </div>
            <div className="story"
                 onMouseDown={handleMouseDown}
                 onMouseUp={handleMouseUp}
                 onClick={handleMouseClick}
                 onTouchStart={handleMouseDown}
                 onTouchEnd={handleMouseUp}>
              <img ref={storyImgRef}
                   className='story-img'
                   loading="lazy"
                   src={(pageID === "physical-relaxation" ?
                     SleepTipsRelaxationStoriesData : BetterSleepTipsStoriesData)[currentIndex].src}
                   alt="Story"/>
              <p ref={storyRecommendationRef}
                 className='story-recommendation'>
                {(pageID === "physical-relaxation" ?
                  SleepTipsRelaxationStoriesData : BetterSleepTipsStoriesData)[currentIndex].recommendation}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SleepTipsPage;



